import { useContext } from 'react';
import { AppContext, EMPTY_OBJECT } from 'commons-ui';

import { DASHBOARD_RESOURCES } from 'constant';
import { URL } from '../../helper';
import useService from '../utils/useService';

export const makeActionHandler = (action: any, params: any) => {
	const { history, rowData = EMPTY_OBJECT, setShowLoader, setForceUpdateRows, setConfirmationDialog } = params;
	const { showAlert } = useContext(AppContext);
	const { addCoinsFromCsv } = useService();

	switch (action.id) {
		case 'add':
			return () => {
				history.push({
					pathname: `${URL[DASHBOARD_RESOURCES.wallet]}/create`
				});
			};
		case 'creditCoins': {
			const toggleIsDisabled = async () => {
				setShowLoader(true);
				try {
					await addCoinsFromCsv(rowData._id);
					showAlert('In processing, please check after some time');
					setForceUpdateRows(true);
				} catch (error: any) {
					showAlert(`Error: ${error?.response?.data?.error}`, { type: 'error' });
				}
				setShowLoader(false);
			};

			return () => {
				setConfirmationDialog({
					show: true,
					header: 'Please Confirm',
					message: 'Are you sure you want to credit coins?',
					handleAlertConfirmation: toggleIsDisabled
				});
			};
		}
		default:
			return () => {};
	}
};

export default {
	makeActionHandler
};
